import Announcement from "./Announcement";
import ExpandOnHover from "./shared/ExpandOnHover";

const AnnouncementList = ({ announcements }) => {
  return (
    <div className="level table-container">
      {announcements.length !== 0 &&
        announcements.map((announcement) => (
          <ExpandOnHover key={announcement._id}>
            <Announcement
              title={announcement.title}
              description={announcement.description}
              link={announcement.link}
              priority={announcement.priority}
            />
          </ExpandOnHover>
        ))}
    </div>
  );
};

export default AnnouncementList;
